import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';


export const ListaVideosDrop = ({ items, onDragEnd, handleInputChange, deleteItem }) => {

    console.log(items);
    return (
        <div className='container'>
            <div className=' p-3 mb-2 d-none d-md-none d-lg-block'>

                <div className='row '>

                    <div className='col-lg-1 col-12 text-center fw-bold'> Ítem </div>
                    <div className='col-lg-4 col-12 text-center fw-bold'>Título </div>
                    <div className='col-lg-4 col-12 text-center fw-bold'>Código </div>
                    <div className='col-lg-1 col-12 text-center fw-bold'> </div>

                </div>

            </div>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="list">
                {(provided) => (
                    <div 
                        style={{ maxHeight: '600px', overflowY: 'auto', padding: '2em' }}
                        className='container rounded shadow p-3'
                        ref={provided.innerRef} 
                        {...provided.droppableProps}
                    >
                        {items.map((item, index) => (
                        
                            <Draggable key={item.uidVideo} draggableId={item.uidVideo} index={index}  >
                            {(provided) => (
                                <div 
                                className=" row bg-light p-3 shadow m-auto mb-2"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                >
                                    <div className='col-lg-1 col-12 fw-bold mt-2'>
                                        { index+1 }
                                    </div>

                                    <div className='col-lg-5 col-12 mb-1'>
                                        <label className=' d-lg-none d-md-block d-sm-block d-block' >
                                            Título
                                        </label>
                                            <input
                                                type="text"
                                                defaultValue={item.videoTitulo}
                                                className='form-control'
                                                onBlur={(ev) => handleInputChange(ev, 'videoTitulo', item.uidVideo)}
                                            />

                                        
                                    </div>

                                    <div className='col-lg-5 col-12 mb-1'>
                                        <label className=' d-lg-none d-md-block d-sm-block d-block' >
                                            Código
                                        </label>
                                        <input
                                            type="text"
                                            defaultValue={item.videoCodigo}
                                            className='form-control'
                                            onBlur={(ev) => handleInputChange(ev, 'videoCodigo', item.uidVideo)}
                                        />
                                        
                                    </div>

                                    <div className='col-lg-1 col-12 mt-1'>
                                        <button
                                            className='btn btn-sm btn-danger'
                                            onClick={() => deleteItem( item.uidVideo ) }
                                        > 
                                        <i className='fa-solid fa-minus'></i>
                                        </button>
                                    </div>
                                </div>
                            )}
                            </Draggable>

                        
                    ))}
                    {provided.placeholder}
                    </div>
                )}
                </Droppable>
            </DragDropContext>
        </div>
    );
  };


